import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SharedService {
  private static isInitialized = false;

  private bannerVisibleSubject = new BehaviorSubject<boolean>(true);
  bannerVisible$ = this.bannerVisibleSubject.asObservable();

  constructor() {
    if (!SharedService.isInitialized) {
      this.initializeBannerVisibility();
      SharedService.isInitialized = true;
    }
  }

  private initializeBannerVisibility() {
    const storedValue = localStorage.getItem("bannerVisibility");
    this.bannerVisibleSubject.next(
      storedValue ? JSON.parse(storedValue) : true
    );
  }

  closeBannerVisibility() {
    const newValue = !this.bannerVisibleSubject.value;
    this.bannerVisibleSubject.next(newValue);
    localStorage.setItem("bannerVisibility", JSON.stringify(newValue));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts